var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-horario"),
      _vm._v(" "),
      _c("ModificarHorario"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("schedule")]),
          _vm._v(" Crear horarios\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", color: "primary", dark: "" },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.crearActualizarHorario({})
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.add")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Agregar Horario")])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.horarios,
                  "item-key": "id_horario",
                  "no-data-text": "Sin datos",
                  "disable-initial-sort": "",
                  "rows-per-page-items": [10, 25, { text: "Todos", value: -1 }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("tr", { staticClass: "fila-principal" }, [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.grupo))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { width: "1%" } }, [
                            _c(
                              "table",
                              { staticClass: "tabla-jornadas" },
                              _vm._l(items.item.jornadas, function(
                                jornada,
                                index
                              ) {
                                return _c("tr", { key: index }, [
                                  _c("td", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "material-symbols-outlined"
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.jornadas.filter(function(
                                                ele
                                              ) {
                                                return (
                                                  ele.id == jornada.id_jornada
                                                )
                                              })[0].icono
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.jornadas.filter(function(ele) {
                                            return ele.id == jornada.id_jornada
                                          })[0].descripcion
                                        ) + ":\n                    "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(jornada.hora_inicio))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(jornada.hora_fin) +
                                        "\n                  "
                                    )
                                  ])
                                ])
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { attrs: { colspan: "4" } },
                            _vm._l(items.item.horarios, function(
                              horario,
                              index
                            ) {
                              return _c(
                                "tr",
                                {
                                  key: index,
                                  staticClass: "multifila-horario"
                                },
                                [
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(horario.descripcion) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(_vm._s(horario.joranada))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(horario.horario) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(horario.horario_2) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        icon: "",
                                        color: "primary",
                                        dark: "",
                                        outline: ""
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.crearActualizarHorario(
                                            items.item
                                          )
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("edit")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Editar registro")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        color: "red",
                                        icon: "",
                                        dark: "",
                                        outline: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.eliminarHorario(items.item)
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Eliminar registro")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04381925", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04381925","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/horario/Index.vue
// module id = null
// module chunks = 